<template>
  <div
    id="login"
    :style="{ height: clientHeight + 'px' }"
    class="content self_c"
  >
    <!-- <headNav rightText="Eng/中" :back="true" @rightClick="toRegister" :flag="true" /> -->
    <headNav
      :back="true"
      :sel_color="window_.color"
      title=" "
      :flag="true"
      :r_title1="window_.r_title1"
      :r_title2="window_.r_title2"
      :select="window_.select"
      :rightC="changeLang"
    />
    <div class="self_b">
      <div class="cell-content self-content">
        <div
          class="cell-title self_cell-title"
          slot="title"
        >
          {{ window_c["Login"] }}
        </div>
        <p
          class="cell-desc self_cell-desc"
          slot="title"
        >
          {{ window_c["Login to get offer"] }}
        </p>
        <div class="self_cell-group_title self_cell-group_title_1">
          {{ window_c["Mobile number"] }}
        </div>
        <!--  -->
        <div class="areaCode">
          <area-code @change="selectCountry" />
          <van-field
            class="self_cell-input"
            v-model="form.phone"
            type="number"
            :maxlength="phoneMaxLength"
            @input="phoneReg"
            center
            clearable
            :placeholder="window_c['Enter your mobile number']"
          ></van-field>
        </div>
        <div class="self_cell-group_title">{{ window_c["Password"] }}</div>
        <van-field
          class="self_cell-input self_bottom_0"
          v-model="form.password"
          maxlength="20"
          clearable
          :type="!isshow ? 'password' : 'text'"
          :placeholder="window_c['Enter your password within 6-20 words']"
          @input="passwordInput"
          @click="passwordClick"
          autocomplete="off"
        >
          <img
            class="cell-icon"
            v-if="!isshow"
            @click="viewPassword"
            src="../assets/biyan.png"
            slot="right-icon"
            alt
          />
          <img
            class="cell-icon"
            v-else
            @click="viewPassword"
            src="../assets/zhengyan.png"
            slot="right-icon"
            alt
          />
        </van-field>
        <van-cell-group class="cell-box">
          <van-cell title>
            <p
              class="cell-forget self_cell-forget"
              slot="default"
              @click="toGetcode"
            >
              {{ window_c["Forget password"] }}?
            </p>
          </van-cell>
        </van-cell-group>
      </div>
      <div
        class="cell-button"
        style="margin-top:auto;margin-bottom: 15px;"
      >
        <p
          @click="login"
          :style="
            !form.phone ||
            (form.phone &&
              (form.phone.length != 8 && form.phone.length != 11)) ||
            !form.password ||
            (form.password && form.password.length < 6)
              ? 'background-color:#ccc;'
              : 'background-color:' + window_.color
          "
        >
          {{ window_c["Login"] }}
        </p>
      </div>
      <!-- <div class="cell-button" style="margin-bottom: 15px;">
    	<p
    		@click="toRegister"
    	>
    		{{ window_c['Create Account'] }}
    	</p>
    </div> -->

      <div
        style="height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;"
        @click="toRegister"
      >
        {{ window_c["No account, go to register1"] }}
        <span
          class="self_gorest self_color"
          v-html="window_c['No account, go to register2']"
        ></span>
        >
      </div>
      <div></div>
      <!-- <iframe :src="thUrl" style="display: none;"></iframe> -->
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNave";
import myfn from "@/js/util";
import { loginOth, joinBrand } from "@/js/api";
import desUtil from "@/js/DesUtil";
import lang_ from "@/js/locales";
import VConsole from "vconsole";
import areaCode from "@/components/areaCode.vue";
import { Field } from "vant";

export default {
  data () {
    return {
      clientHeight: 603,
      window_c: {
        Login: "登入",
        "Login to get offer": "登入會員攞優惠",
        "Mobile number": "手機號碼",
        "Enter your mobile number": "輸入手機號碼",
        Password: "密碼",
        "Enter your password within 6-20 words": "輸入6-20個字符",
        "Forget password": "忘記密碼",
        "Create Account": "註冊",
        "Please enter your mobile number": "請輸入手機號",
        "Mobile number format error": "手機號碼格式錯誤",
        "Please enter the password": "請輸入密碼",
        "Please enter a password of at least 6 digits":
          "請輸入至少6位数以上密碼",
        "Login...": "登入中...",
        "Login successfully": "登入成功",
        "No account, go to register1": "沒有賬號,去",
        "No account, go to register2": "註冊"
      },
      window_: {
        color: "",
        de_img: "../../assets/icon/small_default.png",
        r_title1: "Eng",
        r_title2: "中",
        select: 1
      },
      form: {
        phone: "",
        password: ""
      },
      isshow: false,
      isPasswordFours: false,
      thUrl: "",
      // 区号信息
      loginData: {
        countryData: [], // 城市 數據
        countryId: 1
      },
      phoneMaxLength: "8"
    };
  },
  created () {
    myfn.selfSetIcon(); // 設置logo
    myfn.getBrand(this, () => {
      this.window_.color = this.themeColor;
    });
    let userInfoStr = myfn.userInfo.get(this)
    if (userInfoStr) {
      this.$router.replace({
        name: "vipCard",
        params: {
          arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
        }
      });
    }
    this.window_.select = localStorage.foodStoryLanguage || 'hk';
  },
  mounted () {
    this.clientHeight = window.innerHeight || 603;
    this.init_lang();
    this.form.password = "";
    setTimeout(function () {
      var c = document.getElementsByClassName("self_bottom_0");
      c[0].children[0].children[0].children[0].value = "";
    }, 300);
  },
  methods: {
    // 监听 input 中手机号各式是否正确

    // 修改当前选择区号id
    selectCountry (item) {
      this.loginData.countryId = item.id;
      if (item.id == 3) {
        this.phoneMaxLength = 11
      } else {
        this.phoneMaxLength = 8
      }
    },
    verifyCid (phone, cId) {
      // 判断当前cID跟号码长度是否匹配
      if (
        ((cId == 1 || cId == 2 || cId == 4) && phone.length == 8) ||
        (cId == 3 && phone.length == 11)
      ) {
        return 0; // 成功
      } else {
        return 1; // 失败
      }
    },
    init_lang () {
      // localStorage.foodStoryLanguage = 'en';
      var window_c = this.window_c;
      window_c["Login"] = lang_.t("Login");
      window_c["Login to get offer"] = lang_.t("Login to get offer");
      window_c["Mobile number"] = lang_.t("Mobile number");
      window_c["Enter your mobile number"] = lang_.t(
        "Enter your mobile number"
      );
      window_c["Password"] = lang_.t("Password");
      window_c["Enter your password within 6-20 words"] = lang_.t(
        "Enter your password within 6-20 words"
      );
      window_c["Forget password"] = lang_.t("Forget password");
      window_c["Create Account"] = lang_.t("Create Account");
      window_c["Please enter your mobile number"] = lang_.t(
        "Please enter your mobile number"
      );
      window_c["Mobile number format error"] = lang_.t(
        "Mobile number format error"
      );
      window_c["Please enter the password"] = lang_.t(
        "Please enter the password"
      );
      window_c["Please enter a password of at least 6 digits"] = lang_.t(
        "Please enter a password of at least 6 digits"
      );
      window_c["Login..."] = lang_.t("Login...");
      window_c["Login successfully"] = lang_.t("Login successfully");
      window_c["No account, go to register1"] = lang_.t(
        "No account, go to register1"
      );
      window_c["No account, go to register2"] = lang_.t(
        "No account, go to register2"
      );
    },
    toRegister () {
      this.$router.push({
        name: "register",
        params: {
          arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
        }
      });
    },
    toGetcode () {
      this.$router.push({
        name: "get_password",
        params: {
          arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
        }
      });
      if (this.form.phone.length == 11 && this.loginData.countryId != 3) {
        this.$toast(self.window_c["Mobile number format error"]);
        return
      } else if (this.loginData.countryId != 3 && this.form.phone.length != 8) {
        this.$toast(self.window_c["Mobile number format error"]);
        return
      }
    },
    login () {
      var form = this.form;
      var self = this;
      let a = this.verifyCid(form.phone, this.loginData.countryId);
      if (a != 0) {
        this.$toast(this.window_c["Mobile number format error"]);
        return;
      }
      if (
        !form.phone ||
        (form.phone && (form.phone.length != 8 && form.phone.length != 11)) ||
        !form.password ||
        (form.password && form.password.length < 6)
      ) {
        this.$toast(this.window_c["Mobile number format error"]);
        return;
      }
      if (!this.form.phone) {
        this.$toast(this.window_c["Please enter your mobile number"]);
      } else if (!regExpPhone.test(this.form.phone)) {
        this.$toast(this.window_c["Mobile number format error"]);
      } else if (!this.form.password) {
        this.$toast(this.window_c["Please enter the password"]);
      } else if (this.form.password && this.form.password.length < 6) {
        this.$toast(
          this.window_c["Please enter a password of at least 6 digits"]
        );
      } else {
        var data = {
          // phone: this.form.phone,
          // password: desUtil.encode(this.form.password, desUtil.deskey),
          // type: 1,
          // mobileToken: myfn.randomWord(true, 24, 48),
          // countryId: this.loginData.countryId
          phone: this.form.phone,
          password: this.form.password, //desUtil.encode(this.form.password, desUtil.deskey),
          type: 1,
          mobileToken: myfn.randomWord(true, 24, 48),
          countryId: this.loginData.countryId
        };
        this.$toast.loading({
          message: self.window_c["Login..."],
          forbidClick: true,
          loadingType: "spinner"
        });
        loginOth(data).then(res => {
          console.log(11, res);
          if (res.success) {
            let data = res.data;
            data.memberInfo.memberId = data.memberInfo.id;
            myfn.userInfo.set(this, data.memberInfo);
            self.$toast(self.window_c["Login successfully"]);
            joinBrand({
              memberId: data.memberInfo.id,
              phone: data.memberInfo.phone,
              brandId: myfn.getBrandId(this, 1)
            }).then(result => {
              setTimeout(() => {
                self.$router.replace({
                  name: "vipCard",
                  params: {
                    arg: myfn.setQueryParams(myfn.getBrandId(this, 1))
                  }
                });
              }, 500);

            });
          } else {
            // 用戶未註冊
            if (res.errCode == "LOGIN.0007") {
              this.$toast("賬戶尚未註冊!");
            } else if (res.errCode == "SMS.0001") {
              this.$toast("短信驗證碼錯誤!");
            } else if (res.errCode == "LOGIN.0020") {
              this.$toast("會員登錄錯誤次數太多,請稍後重試!");
            } else if (res.errCode == "LOGIN.0005") {
              this.$toast("帳戶已暫停，請聯絡客戶服務email!");
            } else if (res.errCode == "LOGIN.0006") {
              this.$toast("帳戶已過期，請聯絡客戶服務email!");
            } else {
              this.$toast(res.errMsg);
            }
          }
        });
      }
    },

    viewPassword () {
      this.isshow = !this.isshow;
    },
    //
    phoneReg (e) {
      var val = myfn.numberRegex(e);
      this.form.phone = val;
    },
    changeLang () {
      var l = localStorage.foodStoryLanguage;
      // console.log(l);
      if (l == "en") {
        // location.replace(location.href.replace("login/en", "login/hk"));
        localStorage.foodStoryLanguage = "hk";
      } else {
        // location.replace(location.href.replace("login/hk", "login/en"));
        localStorage.foodStoryLanguage = "en";
      }
      location.reload();
    },
    // 密碼框 如果沒有 獲取焦點/自动填充也会获取焦点 但是不会触发点击 然后有 自動填充  則去掉
    passwordInput (e) {
      if (!this.isPasswordFours) {
        this.form.password = "";
        setTimeout(function () {
          var c = document.getElementsByClassName("self_bottom_0");
          c[0].children[0].children[0].children[0].value = "";
        }, 300);
      }
    },
    passwordClick () {
      this.isPasswordFours = true;
    }
  },
  components: {
    headNav,
    areaCode
  }
};
</script>

<style scoped lang="less">
.areaCode {
  display: flex;
  margin: 16px 0;
  & /deep/ .van-cell {
    margin: 0 !important;
  }
}
.self-content {
  padding: 0 16px !important;
}

#login .van-hairline--top-bottom:after,
#login .van-hairline-unset--top-bottom:after {
  border-width: 0;
}

#login .van-cell-group__title {
  color: #000;
  /* padding: 14px 16px 0px; */
}

#login .van-cell__value,
#login .van-cell__value--alone {
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 8px;
}

#login .cell-box .van-cell__value,
#login .cell-box .van-cell__value--alon {
  border: none;
  padding-bottom: 0;
}

#login {
  background: #fff;
  display: flex;
  flex-direction: column;
}

.cell-content {
  padding-top: 30px;
  /* margin-bottom: 220px; */
}

.cell-title {
  font-size: 60px;
  color: #000;
}

.cell-desc {
  font-size: 26px;
  color: #222;
  margin: 20px 0 60px;
}

.cell-icon {
  width: 25px;
  height: 25px;
  margin-top: 10px;
}

.cell-button p {
  width: calc(100% - 20px);
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #5abba7;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 17px;
}

.cell-button p:active {
  opacity: 0.8;
}

.cell-forget {
  color: #333;
  font-size: 30px;
  text-align: right;
}

/*
  .self_title_1{
      padding-top: 43px !important;
  } */

.self_bottom_0 {
  margin-bottom: 0 !important;
}

.self_cell-forget {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-right: 27.5px;
}

.self_gorest {
  color: #5abba7;
}

.self_b {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue